export enum EdiMessageType {
	Forecast = 0,
	Order = 10,
	ShippingNote = 20,
	CSV = 40,
	Manual = 50,
	Unknown = 999,
}